"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Carousel = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var services_1 = require("@falcon/services");
var Carousel = /** @class */ (function (_super) {
    __extends(Carousel, _super);
    function Carousel(props) {
        var _this = _super.call(this, props) || this;
        _this.intervalTime = 6000;
        _this.carouselEnabled = false;
        _this.state = {
            carouselBanners: [],
            currentIndex: 0
        };
        _this.setCurrentIndex = _this.setCurrentIndex.bind(_this);
        return _this;
    }
    Carousel.prototype.componentDidMount = function () {
        var _this = this;
        this.getSettings(function (settings) {
            // FAL-42264: max banner count should be: 5
            var banners = _this.getBanners((settings === null || settings === void 0 ? void 0 : settings.availableCarouselBanners) ? settings === null || settings === void 0 ? void 0 : settings.availableCarouselBanners : "");
            if (banners.length > 1) {
                banners = _this.shuffleArray(banners);
                _this.bannerChangeInterval = window.setInterval(function () { return _this.goToNext(banners); }, _this.intervalTime);
            }
            _this.setState({
                carouselBanners: banners
            });
            _this.carouselEnabled = (settings === null || settings === void 0 ? void 0 : settings.carouselEnabled) ? settings === null || settings === void 0 ? void 0 : settings.carouselEnabled : false;
        });
    };
    Carousel.prototype.componentWillUnmount = function () {
        window.clearInterval(this.bannerChangeInterval);
    };
    Carousel.prototype.render = function () {
        var _this = this;
        var _a;
        var banners = (_a = this.state) === null || _a === void 0 ? void 0 : _a.carouselBanners;
        return this.carouselEnabled && banners.length !== 0 ? ((0, jsx_runtime_1.jsxs)("div", { className: "mb-5 mt-5", children: [(0, jsx_runtime_1.jsx)("div", { className: "carousel-container", children: (0, jsx_runtime_1.jsx)("div", { className: "carousel-track", style: { transform: "translateX(-".concat(this.state.currentIndex * 100, "%)") }, children: banners.map(function (banner) { return ((0, jsx_runtime_1.jsx)("div", { className: "carousel-slide", children: banner.component }, banner.id)); }) }) }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)("div", { className: "center", children: [banners.map(function (banner, index) {
                                return (0, jsx_runtime_1.jsx)("button", { className: "cursor-pointer dot-indicator ".concat(_this.state.currentIndex === index ? "selected-dot-indicator" : ""), onClick: function () { return _this.goToSlide(index); } }, banner.id);
                            }), banners.length > 1 &&
                                (0, jsx_runtime_1.jsx)("button", { className: "btn-text cursor-pointer padding-revert", onClick: function () { return _this.goToNext(banners); }, children: (0, jsx_runtime_1.jsx)("img", { alt: "Arrow icon", src: "/".concat(services_1.resourcesHelper.THEME, "/img/arrow-right.svg") }) })] }) })] })) : (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    };
    Carousel.prototype.goToNext = function (banners) {
        this.setCurrentIndex((this.state.currentIndex + 1) % banners.length);
        this.resetBannerChangeInterval();
    };
    ;
    Carousel.prototype.goToSlide = function (slideIndex) {
        this.setCurrentIndex(slideIndex);
        this.resetBannerChangeInterval();
    };
    ;
    Carousel.prototype.resetBannerChangeInterval = function () {
        var _this = this;
        window.clearInterval(this.bannerChangeInterval);
        this.bannerChangeInterval = window.setInterval(function () { return _this.goToNext(_this.state.carouselBanners); }, this.intervalTime);
    };
    Carousel.prototype.setCurrentIndex = function (slideIndex) {
        this.setState({ currentIndex: slideIndex });
    };
    Carousel.prototype.shuffleArray = function (array) {
        var _a;
        for (var i = array.length - 1; i > 0; i--) {
            // Using Math.random() is acceptable here as this is not security-sensitive context
            var j = Math.floor(Math.random() * (i + 1)); // NOSONAR
            _a = [array[j], array[i]], array[i] = _a[0], array[j] = _a[1];
        }
        return array;
    };
    return Carousel;
}(React.Component));
exports.Carousel = Carousel;
//# sourceMappingURL=Carousel.js.map